import { takeLatest, call, put } from "redux-saga/effects";
import { ROUTE } from "../../route/Route";
import { loader, toast } from "../common/common-reducer";
import { HttpResponse } from "../common/response-model";
import {
  availableSlotAction,
  bookingValidationAction,
  createBookingAction,
  createHomeCollectionAction,
  sendOtpAction,
  storeCartDataAction,
  updateBookingAction,
  verifyOtpAction,
} from "./action";
import {
  bookingResponse,
  otpFailResponse,
  sendOtpResponse,
  setBookingDataResponse,
  setBookingValidationResponse,
  setCheckoutLoading,
  slotResponse,
  verifyOtpResponse,
} from "./reducer";
import { CheckoutService } from "./service";
import { decryptedData, getSelectedCityData, getUser } from "../../constant/utils";
import moment from "moment";
import { submitAction } from "../action";
import { useDispatch } from "react-redux";
import { SubmitService } from "../submit/service";

export function* sendOtp(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(verifyOtpResponse({}));
    yield put(setCheckoutLoading(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().sendOtp, Request);
    let response: any = res;
    if (response?.Success == "True") {
      yield put(sendOtpResponse(response?.Result));
      yield put(otpFailResponse(false));
      yield put(toast({ message: response?.Message, type: "success" }));
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(toast({ message: response?.Message, type: "error" }));
      onError && onError(response);
    }
    yield put(setCheckoutLoading(false));
  } catch (err: any) {
    console.log(err?.response);
    yield put(setCheckoutLoading(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* verifyOtp(data: any) {
  let payload = data.payload;
  let { Request, mobile, onSuccess, onError } = payload;
  try {
    yield put(setCheckoutLoading(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().verifyOtp, Request);
    let response: any = res;
    if (response?.Success === "False") {
      yield put(toast({ message: response?.Message, type: "error" }));
      onError && onError(response);
    } else {
      yield localStorage.setItem("oqu", response || "");
      let user: any = getUser();
      let newData: any = {
        FirstName: user?.FirstName || "",
        LastName: user?.LastName || "",
        Profile_Image: user?.Profile_Image || "",
      };
      yield localStorage.setItem("oqu-user", JSON.stringify(newData));
      const CartData = JSON.parse(localStorage.getItem("CartData") || "[]");
      const selectedCityData: any = getSelectedCityData();
      if (selectedCityData?.IsHcAvailable == 0 && CartData && CartData.length > 0) {
        var TestName: any[] = [];
        Promise.all(
          CartData.map((row: any) => {
            TestName.push(row.TestName);
          })
        );
        const urlParams = new URLSearchParams(window.location.search);
        const payload = {
          Name: "",
          Mobile: mobile,
          CityId: localStorage.getItem("oq:city"),
          Email: "",
          Message: TestName ? TestName.join(",") : "",
          UtmSource: urlParams.get("utm_source"),
          UtmMedium: urlParams.get("utm_medium"),
          UtmCampaign: urlParams.get("utm_campaign"),
        };
        let res: HttpResponse<any> = yield call(SubmitService.getInstance().submitEnquiry, payload);
        localStorage.removeItem("CartData");
        localStorage.removeItem("ocq:cityData");
      }
      onSuccess && onSuccess(response);
    }
    yield put(setCheckoutLoading(false));
  } catch (err: any) {
    yield put(setCheckoutLoading(false));
    if (err.response?.status == 401) {
      yield put(toast({ message: "Incorrect OTP", type: "error" }));
    } else {
      yield put(toast({ message: err.message, type: "error" }));
    }
    onError && onError(err);
  }
}
export function* slot(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  try {
    yield put(slotResponse([]));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().slot, Request);
    let response: any = res;
    yield put(slotResponse(response?.Result?.Slots));
    yield put(loader(false));
    onSuccess && onSuccess(response?.Result?.Slots);
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}
export function* createBooking(data: any) {
  let payload = data.payload;
  let { Request, history, onSuccess, onError } = payload;
  try {
    yield put(setCheckoutLoading(true));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().createBooking, Request);
    let response: any = res;
    if (response?.Success == "True") {
      yield put(bookingResponse(response?.Result));
      yield put(setBookingDataResponse({}));
      if (response?.Result?.PaymentMode === "online") {
        window.location.href = response?.Result?.PaymentUrl;
      } else if (response?.Result?.PaymentMode === "cod") {
        history.push({
          pathname: ROUTE.PAYMENT_THANKYOU,
          state: { type: "cod", bookingId: response?.Result?.CrmBookingId },
        });
      }
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(toast({ message: response.Message, type: "error" }));
      onError && onError(response);
    }
    yield put(loader(false));
    yield put(setCheckoutLoading(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(setCheckoutLoading(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* createHomeCollection(data: any) {
  let payload = data.payload;
  let { Request, history, onSuccess, onError } = payload;
  try {
    yield put(setCheckoutLoading(true));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().createHomeCollection, Request);
    let response: any = res;
    if (response?.Success == "True") {
      history.push({
        pathname: ROUTE.THANKYOU,
        /*  state: { type: "cod", bookingId: response?.Result?.CrmBookingId }, */
      });
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(toast({ message: response.Message, type: "error" }));
      onError && onError(response);
    }
    yield put(loader(false));
    yield put(setCheckoutLoading(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(setCheckoutLoading(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* updateBooking(data: any) {
  let payload = data.payload;
  let { Request, history, onSuccess, onError } = payload;
  try {
    yield put(setCheckoutLoading(true));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().updateBooking, Request);
    let response: any = res;
    onError && onError(response);
    if (response?.Success == "True") {
      yield put(bookingResponse(response?.Result));
      yield put(setBookingDataResponse({}));
      if (response?.Result?.PaymentMode === "online") {
        window.location.href = response?.Result?.PaymentUrl;
      } else {
        yield put(toast({ message: response?.Message, type: "success" }));
        history.push({
          pathname: ROUTE.PAYMENT_THANKYOU,
          state: { type: "cod", page: "update", bookingId: response?.Result?.CrmBookingId || Request?.CrmBookingId },
        });
      }
      onSuccess && onSuccess(response?.Result);
    } else {
      yield put(toast({ message: response.Message, type: "error" }));
      onError && onError(response);
    }
    yield put(loader(false));
    yield put(setCheckoutLoading(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(setCheckoutLoading(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* storeCartData(data: any) {
  try {
    yield put(loader(true));
    let payload = data.payload;
    let { Request } = payload;
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().storeCartData, Request);
    let response: any = res;
    if (response?.Success != "True") {
      yield put(toast({ message: response.Message, type: "error" }));
    }
    yield put(loader(false));
  } catch (err: any) {
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
  }
}

export function* bookingValidation(data: any) {
  let payload = data.payload;
  let { Request, onSuccess, onError } = payload;
  /* if (Request?.PreferredTime) {
    let time = Request?.PreferredTime?.split("to");
    time = time[0]?.trim()?.replace(".", ":");
    Request.PreferredTime = moment(time, "hh:mm A").format("HH:mm");
  } */
  try {
    yield put(setBookingValidationResponse({}));
    yield put(loader(true));
    let res: HttpResponse<any> = yield call(CheckoutService.getInstance().bookingValidation, Request);
    let response: any = res;
    yield put(setBookingValidationResponse(response?.Result));
    yield put(loader(false));
    if (
      response?.Result?.orderStatusInCity?.status == true &&
      response?.Result?.orderStatusInCity?.isServiceActive == false
    ) {
      yield put(toast({ message: response?.Result?.orderStatusInCity?.message, type: "error" }));
    }
    if (response?.Result?.orderStatusInCity?.status == false) {
      yield put(toast({ message: response?.Result?.orderStatusInCity?.message, type: "error" }));
    }
    onSuccess && onSuccess(response?.Result);
  } catch (err: any) {
    yield put(setBookingValidationResponse({}));
    yield put(loader(false));
    yield put(toast({ message: err.message, type: "error" }));
    onError && onError(err);
  }
}

export function* userEffects() {
  yield takeLatest(sendOtpAction.type, sendOtp);
  yield takeLatest(verifyOtpAction.type, verifyOtp);
  yield takeLatest(availableSlotAction.type, slot);
  yield takeLatest(createBookingAction.type, createBooking);
  yield takeLatest(createHomeCollectionAction.type, createHomeCollection);
  yield takeLatest(updateBookingAction.type, updateBooking);
  yield takeLatest(storeCartDataAction.type, storeCartData);
  yield takeLatest(bookingValidationAction.type, bookingValidation);
}

const checkoutSagas = [call(userEffects)];

export default checkoutSagas;
